var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNocompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "122px",
    viewBox: "0 0 80 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Costa-Rica",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Factura_electronica_perfil_vacio",
    transform: "translate(-1068.000000, -530.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1071.000000, 530.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.97114187,4.59789497 L5.23701131,4.8438022 C7.85399351,7.26429423 11.9240618,7.15515588 14.4075662,4.59789497 C16.8535474,2.07927169 20.8781545,2.02038362 23.3967777,4.46636477 C23.4092345,4.47846223 23.4216416,4.49061068 23.4339988,4.50280981 L23.7907109,4.85495937 C26.1066366,7.14126273 29.8374803,7.11724913 32.1237837,4.80132349 C32.1892221,4.73503723 32.2530796,4.66720865 32.3153023,4.59789497 C34.5958891,2.05741049 38.5030556,1.84378232 41.0470265,4.12047934 L42.0812246,5.0460228 C44.6491201,7.34413082 48.5890954,7.14417262 50.9111328,4.59789497 C53.192037,2.09672279 57.0686759,1.91816033 59.5698481,4.19906454 C59.5927139,4.21991672 59.6154216,4.24094177 59.637969,4.26213789 L60.1695432,4.76185407 C62.7943599,7.22936151 66.9071255,7.15664646 69.4430763,4.59789497 C70.4789439,3.55271388 72.1659672,3.54516381 73.2111483,4.58103142 C73.7159974,5.08138193 74,5.76270855 74,6.47349918 L74,114.914498 C74,116.428062 72.7730143,117.655048 71.2594506,117.655048 C70.5902536,117.655048 69.9441821,117.410195 69.4430763,116.966667 C66.8285964,114.65259 62.9101568,114.613921 60.2505167,116.875948 L59.9157277,117.160687 C57.3413601,119.35019 53.535859,119.266817 51.0598534,116.966667 C48.5942111,114.676144 44.7949182,114.623934 42.2672662,116.845839 L42.129812,116.966667 C39.499559,119.278762 35.5671811,119.297364 32.9151712,117.010257 L32.8646258,116.966667 C30.1655378,114.638959 26.1794729,114.602873 23.4386851,116.881333 L23.0016521,117.244646 C20.4234733,119.387926 16.6508621,119.268597 14.2132869,116.966667 C11.7683869,114.657819 7.99184118,114.515824 5.38046779,116.63456 L4.97114187,116.966667 C3.66320386,118.027861 1.74264224,117.827837 0.681447423,116.519899 C0.240600761,115.976549 2.76192191e-14,115.298132 0,114.598435 L0,6.77147618 C2.43837159e-16,5.13629409 1.32557699,3.8107171 2.96075907,3.8107171 C3.70607901,3.8107171 4.42398036,4.09181583 4.97114187,4.59789497 Z",
    id: "Rectangle",
    stroke: "#D8D8D8",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 23.000000)",
    stroke: "#979797",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeLinejoin: "round",
    x: 0,
    y: 0,
    width: 58,
    height: 8.97727273
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    strokeLinejoin: "round",
    x: 0,
    y: 26.9318182,
    width: 32.625,
    height: 8.97727273
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    strokeLinejoin: "round",
    x: 35.34375,
    y: 70.9204545,
    width: 22.65625,
    height: 8.07954545
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,17.9545455 L58,17.9545455",
    id: "Path-10",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,43.0909091 L20.84375,43.0909091",
    id: "Path-10-Copy",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,52.0681818 L20.84375,52.0681818",
    id: "Path-10-Copy-2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,61.0454545 L20.84375,61.0454545",
    id: "Path-10-Copy-3",
    strokeLinecap: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNocompanies);
export default __webpack_public_path__ + "static/media/ic_nocompanies.cf889e44d79f1b9981faed5564c4b050.svg";
export { ForwardRef as ReactComponent };